<div [class]="'z-1 relative bg-primary p-3 flex justify-content-center align-items-center flex-wrap ' + (blockClass ? (blockClass + ' ') : '') + theme.current.card + (block.class_overwrite ? (' ' + block.class_overwrite) : '' )">
    <div class="align-items-center lg:flex">
        <span [innerHTML]="block.title | safeHTML" class="line-height-3 [&>p]:m-0"></span>
    </div>
</div>

